import * as React from "react";
import { Helmet } from "react-helmet";
import { fetchData, postQuery, uploadFile } from '../utils'
import * as AuthStore from "../store/Auth";
import { ApplicationState } from '../store';
import * as Highcharts from 'highcharts';
import { connect } from "react-redux";
import { Table, Button, Select, Upload, message, Card, Form, Row, Col, Modal, Input } from 'antd';
import { InboxOutlined, CloseCircleOutlined, SearchOutlined, EditFilled, PlusCircleOutlined } from '@ant-design/icons';
import { busyGif } from '../img';
const { Option } = Select;
const { Item } = Form;
const { Dragger } = Upload;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

interface Reason
{
    Id: string;
    name: string;
    [key: string]: Reason[keyof Reason];
}

class CounsellingReason extends React.Component<AuthProps>
{
    public state =
    {
        buttonText: 'Add',
        data: [],
        pagination:
        {
            current: 1,
            total: 0,
            pageSize: 10,
            sorter: {
                field: "name",
                order: "asc"
            }
        },
        loading: false,
            confirmLoading: false,
            fLoading: false,
        title: 'New Reason',
        reason: { Id: '', name: ''},
        searchText: "",
        visible: false,
        hideUpload: false,
        showDetails: false
    };

    async componentDidMount()
    {
        const { pagination } = this.state;

        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current,
            sortField: pagination.sorter.field,
            sortOrder: pagination.sorter.order
        });
    }
    
    handleTableChange(pagination: any, filters: any, sorter: any)
    {
        const pager = this.state.pagination;
        pager.current = pagination.current;

        this.setState({
            pagination: pager
        });
        this.getItems({
            results: pager.pageSize,
            searchText: this.state.searchText,
            page: pager.current,
            sortField: pager.sorter.field,
            sortOrder: pager.sorter.order
        });
    }  
 
    async getItems(params: any)
    {
        this.setState({ loading: true });
        var searchText = params.searchText;
        var results = params.results;
        var page = params.page;
        let el = this;

        var query = `/api/Jolly95/getReasonsList?itemsPerPage=${results}&pageNumber=${page}&searchText=${searchText}`;

        let res = await fetchData(query);

        const { pagination } = el.state;
            pagination.total = res.totalItems;           
            el.setState({
                data: res.counsellingReasons,
                pagination,
                loading: false 
            });                      

        if (searchText && searchText.trim().length > 0)
        {
            const reg = new RegExp(searchText, 'gi');
            this.setState({
                filtered: !!searchText,
                data: this.state.data.map((record: any) =>
                {
                    const match = record.name.toString().match(reg);

                    if (!match)
                    {
                        return null;
                    }
                    return {
                        ...record,
                        name: (<span> {record.name.split(reg).map((text: any, i: any) => (i > 0 ? [<span key={record.id} className="highlight">{match[0]}</span>, text] : text
                        ))}
                        </span>
                        )
                    };
                }).filter(record => !!record)
            });
        }
    }

    handleChange(value: any)
    {
        const { pagination } = this.state;
        pagination.pageSize = parseInt(value);

        this.setState({
            pagination: pagination
        });

        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current
        });
    }
    
    onInputChange(e: any)
    {
        let searchTerm = e.target.value.trim();
        this.setState({searchText: searchTerm});       
    }
      
    onSearch()
    {
        let el = this;
        const { pagination } = el.state;
        if (!el.state.searchText || el.state.searchText.length < 1)
        {
            message.error('Please provide a Counselling Request Reason');
            return;
        }
        this.getItems({
            results: pagination.pageSize,
            searchText: el.state.searchText,
            page: pagination.current
        });
    }

    edit(data: any, row: any)
    {
        this.setState({ visible: true, title: 'Update Reason', buttonText: 'Update', reason: data });
    }

    Add()
    {
        this.setState({ visible: true, title: 'Add Reason', buttonText: 'Add', reason: { id: '', name: ''} });
    }

    fileControlClicked()
    {
        var ecl = document.getElementById("txSel");
        if (ecl)
            ecl.click();
    }

    dwnTemplate()
    {
        //@ts-ignore
        window.location = "/templates/facilites.xlsx";
    }

    startUpload() {
        this.setState({hideUpload: true});
    }

    async process()
    {
        let el = this;
        if (!el.state.reason.name)
        {
            message.error('Provide all required input and try again');
            return;
        }
        let url = '';
        let payload = {};
        // @ts-ignore
        if (!el.state.reason.id || el.state.reason.id.length < 1) 
        {
            url = '/api/Jolly95/addCounsellingReason';
            payload = { name: el.state.reason.name};
        }
        else
        {
            url = '/api/Jolly95/updateCounsellingReason';
            // @ts-ignore
            payload = { id: el.state.reason.id, name: el.state.reason.name};
        }

        const { pagination } = el.state;
        let params =
        {
            results: pagination.pageSize,
            searchText: el.state.searchText,
            page: pagination.current
        };

        el.setState({ confirmLoading: true });
        let res = await postQuery(url, JSON.stringify(payload));
        el.setState({ confirmLoading: false });
        if (res.code > 0)
        {
            el.getItems(params);
            el.setState({ visible: false });
            message.success(res.message);
        }
        else
        {
            message.error(res.message);
        }
    }
        
    exit() {
        this.setState({
            visible: false, hideUpload: false
        });
    }
    
    textChange(feture: any, e: any)
    {
        let reason = this.state.reason;        
        reason[feture] = e.target.value;
        this.setState({ reason });
    }

    async upload(file: any)
    {
        //let file = e.target.files[0];
        let form = new FormData();
        form.append('file', file);
        form.append('fileName', file.name);
        console.log(form);
        this.setState({ confirmLoading: true });
        let res = await uploadFile('/api/Site/uploadSites', form);
        this.setState({ confirmLoading: false });

        if (res.code < 1)
        {
            message.error(res.message);
        }
        else
        {
            message.success(res.message);
            const { pagination } = this.state;
            this.setState({ hideUpload: false });
            this.getItems({
                results: pagination.pageSize,
                searchText: this.state.searchText,
                page: pagination.current,
                sortField: pagination.sorter.field,
                sortOrder: pagination.sorter.order
            });
        }
    }

    closeView()
    {
        this.setState({ showDetails: false });
    }

    render()
    {
        const { title, confirmLoading, visible, showDetails, reason, searchText, buttonText } = this.state;
        let el = this;
        const user = this.props.appUser;

        const columns =
            [
                {
                title: 'Counselling Reason',
                dataIndex: 'name',
                key: 'name',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Edit',
                    dataIndex: '', key: 'x',
                    render: (value, row, index) => <EditFilled onClick={() => this.edit(value, row)} key={value.id} style={{ cursor: 'pointer' }} />
                }
            ]; 

        return (
            <div style={{ marginTop: '15px', padding: '20px' }}>
                <Helmet>
                    <title>CDR - Counselling Reasons</title>
                </Helmet>                
                <div className="custom-filter-dropdown" style={{ display: showDetails ? 'none' : 'block' }}>
                    <Row style={{ marginTop: '2px' }}>
                        <Col span={24}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Counselling Reasons</h4>
                        </Col>
                    </Row>
                    <Row gutter={2}>
                        <Col xs={24} sm={24} md={3} lg={3}>
                            <Select className="top-10-margin" defaultValue="10" id="pageSize" onChange={(v) => this.handleChange(v)}>
                                <Option value="10">10</Option>
                                <Option value="25">25</Option>
                                <Option value="50">50</Option>
                                <Option value="100">100</Option>
                            </Select>
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                            <Input className="ant-input-lg-2 top-10-margin" style={{ width: '100%' }} placeholder="Search by name or State code..." value={searchText} onChange={(s) => el.onInputChange(s)} onPressEnter={() => el.onSearch()} />                                                       
                        </Col>
                        <Col xs={24} sm={24} md={16} lg={16}>
                            <Button disabled={confirmLoading} className="login-button top-10-margin" id="push-btn" key="submit" size="large" onClick={() => this.Add()} style={{ float: 'right', marginRight: '25px', width: '15%' }} icon={<PlusCircleOutlined />}>
                                <span id="buttonText">New Reason</span>
                            </Button>
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                        </Col>
                    </Row>
                    <br />
                    <Row gutter={2}>
                        <Col span={24} style={{overflow: "scroll"}}>
                            <Table columns={columns} rowKey={record => record.id} dataSource={this.state.data} pagination={this.state.pagination} loading={this.state.loading} onChange={(a: any, b: any, c: any) => this.handleTableChange(a, b, c)} bordered />
                        </Col>
                    </Row>
                </div>

                <div className="md-wrapper">
                    <Modal className="modal-width-500"
                        visible={visible}
                        title={title}
                        maskClosable={false}
                        onCancel={() => this.exit()}
                        footer={[
                            <Button loading={confirmLoading} disabled={confirmLoading} style={{ width: '25%' }}  className="login-button" key="submit" type="primary" size="large" onClick={() => this.process()}>
                                <span id="buttonText">{buttonText}</span>
                            </Button>
                        ]}>
                        <Form>
                            <div className='ant-row'>
                                <div className='ant-col-24 padding-md'>
                                    <Item>
                                        <input onChange={(e) => this.textChange('name', e)} name="name" type="text" className="ant-input ant-input-lg input-no-border" placeholder="Counselling Reason" value={reason.name} />
                                    </Item>
                                </div>
                            </div>
                        </Form>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(CounsellingReason as any);
